@if (spinner == null || spinner.isLoading) {
  <div class="lc-spinner-container" [class.loading-overlay]="showOverlay">
    <div class="spinner-text fx-row fx-gap-sm" [class.fixed-center]="fixedCenter">
      <mat-spinner [diameter]="size || 24" />
      @if ((spinner?.text ?? spinnerText); as text) {
        <span class="mat-caption text-primary">{{text}}</span>
      }
    </div>
  </div>
}
